import { render } from "./index.vue?vue&type=template&id=7cb58b46&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=7cb58b46&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=7cb58b46&lang=scss"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cb58b46"]])

export default __exports__